import { AxiosResponse } from 'axios';
import { useAxios } from '../../composables/axios';
import { Law } from './law.model';

const axios = useAxios();

export interface LawService {
  Fetch: () => Promise<AxiosResponse<Law[]>>;
}

const Fetch = (): Promise<AxiosResponse<Law[]>> =>
  axios.Get<Law[]>('api/laws');

export default { Fetch } as LawService;
